import store from '@state/store'
import con from '@services/connection'
import { minhaCarteira } from '@constants/URL'
import { formatQueryParams } from '@utils/Format'

class APIListaClientes {
  constructor() {
    this.loading = false
    this.lastUpdate = null
  }

  /**
   * Carregar clientes.
   *
   * @param {Object} [params]
   * @param {boolean} [params.includeInactive=false] - Quando true, inclui
   *   clientes inativos no resultado retornado E NÃO grava o resultado na
   *   store compartilhada `user/allClients` — sem essa guarda, o universo
   *   completo (ativos + inativos) vazaria para todos os ~69 consumidores da
   *   store assim que qualquer tela pedisse o universo completo (ex.: /clientes).
   * @returns {Promise<*[]>} Lista de clientes normalizada
   */
  async carregar({ includeInactive = false } = {}) {
    if (this.loading && !includeInactive) {
      return store.getters['user/allClients']
    }

    const url =
      minhaCarteira.listar_clientes +
      formatQueryParams({ include_inactive: includeInactive || undefined })
    const r = await con.get(url)

    if (!r || r.status !== 200) {
      return []
    }

    const lista = (r.value || [])
      .sort((a, b) => {
        return ('' + a.nome_cliente).localeCompare(b.nome_cliente)
      })
      .map((v, i) => {
        return {
          ...v,
          id: v.id || (v.id_cadastro_cliente || i) * -1,
          id_cadastro_cliente: v.id_cadastro_cliente,
          name: v.nome_cliente || '',
          login: v.login || '',
          // `email` é o e-mail de CONTATO; `login` é a CREDENCIAL de acesso —
          // colunas diferentes de `app_clientes` que o front tratou como
          // sinônimas por anos. Declarado aqui (e não só herdado do spread)
          // para o campo existir como String em todos os itens: sem isso,
          // `item.email` vem `undefined` no ramo de prospect e em resposta
          // antiga, e `emailDoCliente` (@utils/clienteEmail) cai no login —
          // que é justamente o placeholder `@lead.com` que a operação via.
          email: v.email || '',
          id_cliente_web: v.id_cliente_web,
        }
      })

    if (!includeInactive) {
      store.dispatch('user/setClients', lista)
      this.lastUpdate = new Date()
    }

    return lista
  }
}

const apiListaClientes = new APIListaClientes()
export default apiListaClientes
